import React from 'react';
import { Form } from '@dashboard/components/Formik';
import useProduct from '../useProduct';

export default function ProductMediaForm() {
  const { product, updateProduct } = useProduct();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        media: product.media,
      }}
      onSubmit={async values => {
        const { data, error } = await updateProduct.mutateAsync(values);

        return {
          data: data,
          error: error,
        };
      }}
      fields={[
        {
          name: 'media',
          //label: 'Images',
          type: 'images',
        },
      ]}
    />
  );
}
